export default __webpack_public_path__ + "static/media/raspberry-pi-4-labelled.f5e5dcdf.png";